import { useEffect, useRef } from "react";
import logger from "utils/logger";
import { writeProgramDraft } from "features/planner/persistence/programDraftStorage";

export default function useAutosave(draftIdentity, programState, delay = 500, enabled = true) {
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => timeoutRef.current && clearTimeout(timeoutRef.current);
  }, []);

  useEffect(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current);

    if (!enabled || !draftIdentity) {
      timeoutRef.current = null;
      return undefined;
    }

    timeoutRef.current = setTimeout(() => {
      try {
        writeProgramDraft(draftIdentity, programState);
      } catch (err) {
        logger.error("Autosave failed", err);
      }
    }, delay);

    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    };
  }, [programState, draftIdentity, delay, enabled]);
}
